import { createContext } from "react";

const FeatureContext = createContext({
  flags: null,
  setFlags: () => {}, // Not used, but later if API develops feature flagging endpoints
  context: null, // Entity context, derived from the active organization membership
  resolvedFlags: null, // { [flagKey]: { isEnabled, isResolving } } — null keeps checks default-deny
});

export default FeatureContext;
